import { render, staticRenderFns } from "./ratifyAccord.vue?vue&type=template&id=bdf49786&scoped=true&"
import script from "./ratifyAccord.vue?vue&type=script&lang=js&"
export * from "./ratifyAccord.vue?vue&type=script&lang=js&"
import style0 from "./ratifyAccord.vue?vue&type=style&index=0&id=bdf49786&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf49786",
  null
  
)

export default component.exports